import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from "prop-types";
const useStyles = makeStyles(
  (theme) => ({
    detailsLabel: {
      fontFamily: 'Inter',
      fontWeight: 500,
    },
    componentLabel: {
      fontFamily: 'Inter',
      fontWeight: 300,
    },
  }),
  {
    name: 'PriceInfoDialog',
  }
);

interface Props {
  onCancel: () => void;
  open: boolean;
}

const ComponentValidationDialog: React.FC<Props> = ({ open, onCancel, ...props }) => {
  const classes = useStyles();
  return (
    <CustomDialog dialogTitle={t('priceInfo.title')} open={open} onCancel={onCancel} props={props}>
      <DialogContent>
        <Typography className={classes.detailsLabel}>{t('priceInfo.details')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="contained">
          {t('okButtonLabel')}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ComponentValidationDialog;
